module.exports = __webpack_public_path__ + "static/media/58_tn.18e4a3ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/58_tn.jpg
// module id = 546
// module chunks = 0